import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { updateLeadBant } from '../api/leads';
import { notification } from 'antd';

interface UpdateBantPayload {
  leadId: string;
  budgetScore: number;
  authorityScore: number;
  needScore: number;
  timelineScore: number;
}

export function useUpdateLeadBant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ leadId, ...payload }: UpdateBantPayload) =>
      updateLeadBant(leadId, payload),
    onSuccess: (_, variables) => {
      notification.success({ message: 'BANT scores updated' });
      invalidateLeadsViews(queryClient);
      void queryClient.invalidateQueries({ queryKey: ['lead', variables.leadId] });
    },
    onError: () => {
      notification.error({ message: 'Failed to update BANT scores' });
    },
  });
}
